module.exports = __webpack_public_path__ + "img/ZonaMate_icone_Contenuto_bianca.5b485f0e.svg";